import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deletePhoneLine = ({ phoneLineId }: { phoneLineId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/phoneCharges/DeletePhoneLine/${phoneLineId}`);
};

type QueryFnType = typeof deletePhoneLine;

type UseDeletePhoneLineOptions = {
  phoneLineId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeletePhoneLine = ({ config }: UseDeletePhoneLineOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllPhoneLines"]);
      addNotification(`Η Τηλεφωνική γραμμή Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deletePhoneLine,
  });
};
